import React, {useEffect, useImperativeHandle, useRef} from "react";
import {OrderedListOutlined, BorderOutlined, CheckSquareOutlined} from "@ant-design/icons";
import {Button, Input, Modal, Table} from "antd";
import {useModel} from "../../../models";

const OPT_TYPE = {
    ADD: 1,
    REMOVE: 2
}

export default function () {
    const [
        {
            selectedDocument, documentMaterialList, addMaterialModelVisible,
            materialList, materialPageInfo, materialSearchParam, selectedMaterialList
        },
        {
            setAddMaterialModelVisible, setMaterialSearchParam, loadStockData,
            addDocumentMaterial, addSelectedMaterial, setSelectedMaterialList, removeSelectedMaterial
        }
    ] = useModel("purchaseOrder");
    useEffect(() => {
        loadStockData({showMsg: false, data: {pageNum: 1, pageSize: 5}});
    }, []);
    const onOk = async () => {
        //将已选库存配件添加到订单商品明细里
        await addDocumentMaterial(selectedMaterialList.map(el => ({
            id: el.id,
            key: el.id,
            materialId: el.materialId,
            materialName: el.materialName,
            replaceNum: el.replaceNum,
            unitPrice: el.salePrince,
            saleNum: 1,
            discount: 0,
            quantityGifts: 0,
            discountPrice: 0,
            taxAmount: 0,
            isProtect: false,
            materialUnit: el.salePrince,
            orgName: "张家口公司",
            warehouseId: el.warehouseId,
            warehouseName: el.warehouseName,
            shelfId: el.shelfId,
            shelfName: el.shelfName,
            inventoryQuantity: el.inventoryAmount,
            detailsDesc: "备注信息222"
        })));
        setSelectedMaterialList([]);
        //关闭窗口
        setAddMaterialModelVisible(false);
    }
    const onClose = () => {
        setAddMaterialModelVisible(false);
    }
    const onSearch = () => {
        loadStockData({showMsg: false});
    }

    const onAdd = (record) => {
        addSelectedMaterial(record);
    }
    const onRemove = (record) => {
        removeSelectedMaterial(record);
    }
    const Title = () => {
        return (

            <h3 style={{flex: "1"}}>
                <OrderedListOutlined/>
                <span className="margin-left-8">选择配件</span>
                <span className="margin-left-16">销售订单-{selectedDocument.saleOrderCode}</span>
            </h3>

        )
    }
    const columns = (optType) => [
        {
            title: '',
            dataIndex: 'code',
            width: 40,
            render: (text, record, index) => index + 1,
        },
        {
            title: '商品编号',
            dataIndex: 'materialId',
            align: 'left',
        },
        {
            title: '商品名称',
            dataIndex: 'materialName',
        },
        {
            title: '单位',
            dataIndex: 'materialUnit',
        },
        {
            title: '商品品牌',
            dataIndex: 'materialBrand',
        },
        {
            title: '分类代码',
            dataIndex: 'materialSort',
        },
        {
            title: '库存',
            dataIndex: 'inventoryQuantity',
        },
        {
            title: '操作',
            render: (text, record) => (
                optType === OPT_TYPE.ADD ? (<Button
                    type="link"
                    htmlType="button"
                    className="margin-left-8"
                    size="small"
                    disabled={!!selectedMaterialList.find(el => el.id === record.id) || !!documentMaterialList.find(el => el.id === record.id)}
                    onClick={() => onAdd(record)}
                >
                    添加
                </Button>) : (<Button
                    type="link"
                    htmlType="button"
                    className="margin-left-8"
                    size="small"
                    onClick={() => onRemove(record)}
                >
                    移除
                </Button>)),
        },
    ];
    const StockMaterialList = () => {
        return (
            <>
                <div style={{margin: "0 0 8px", display: "flex"}}>
                    <h3 style={{width: "460px", paddingTop: "6px"}}>
                        <BorderOutlined/> 待选配件列表
                    </h3>
                    <div className="detail-list-statistic" style={{textAlign: "right"}}>
                        <Input
                            placeholder="请输入商品编号或商品名称"
                            style={{width: "150px"}}
                            onChange={e => setMaterialSearchParam({searchValue: e})}
                        />
                        <Button className="margin-left-8" type="primary" onClick={onSearch}>查询</Button>
                    </div>
                </div>
                <Table
                    columns={columns(OPT_TYPE.ADD)}
                    dataSource={materialList}
                    bordered
                    pagination={{
                        simple: true,
                        hideOnSinglePage: true,
                        defaultCurrent: 1,
                        defaultPageSize: 15,
                        onChange: (page, pageSize) => {
                            const params = {...materialSearchParam};
                            params.pageNum = page;
                            params.pageSize = pageSize;
                            loadStockData({showMsg: false, data: params});
                        },
                        total: materialPageInfo.total,
                        current: materialPageInfo.pageNum,
                    }}
                    scroll={{x: 'max-content'}}
                />
            </>
        )
    }
    const SelectedStockMaterialList = () => {
        return (
            <>
                <div style={{margin: "8px 0", display: "flex"}}>
                    <h3 style={{width: "460px", paddingTop: "6px"}}>
                        <CheckSquareOutlined/> 已选配件列表
                    </h3>
                    <div className="detail-list-statistic" style={{textAlign: "right"}}>

                    </div>
                </div>
                <Table
                    scroll={{y: 200, scrollToFirstRowOnChange: true}}
                    columns={columns(OPT_TYPE.REMOVE)}
                    dataSource={selectedMaterialList}
                    bordered
                    pagination={false}
                />
            </>
        )
    }
    return (
        <Modal
            title={<Title/>}
            width={1024}
            visible={addMaterialModelVisible}
            onOk={onOk}
            onCancel={onClose}
        >
            <StockMaterialList/>
            <SelectedStockMaterialList/>
        </Modal>
    );
}